module.exports = __webpack_public_path__ + "static/media/veneto-village-15.3a55be9e.jpg";